import React, { useEffect, useState } from 'react'
import MUIStarIcon from '@material-ui/icons/Star'
import poweredByGoog from 'static/powered_by_google_on_white_hdpi.png'

const Rating = ({ rating = 1 }) => (
  <div className="flex">
    {new Array(rating).fill().map((_, idx) => (
      <MUIStarIcon
        key={idx}
        style={{
          color: '#ffbb33',
          width: '20px',
          height: '20px'
        }}
      />
    ))}
  </div>
)

let map

const getPlaceDetail = callback => {
  const request = {
    placeId: 'ChIJsT7VSLpwlVQRGkmIo0GxaY8',
    fields: ['review']
  }
  const service = new google.maps.places.PlacesService(map)

  service.getDetails(request, callback)
}

const ReviewCard = ({ review }) => (
  <div
    className="flex-1 flex flex-col justify-between bg-white rounded-xl p-6 m-2 transition-all duration-200 hover:shadow-lg"
    style={{
      boxShadow:
        '0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07)',
      border: '1px solid #e3e8ee'
    }}
  >
    {/* Quote icon */}
    <div className="mb-4">
      <svg
        className="w-8 h-8 opacity-20"
        style={{ color: '#635bff' }}
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
      </svg>
    </div>

    <p className="text-base text-textSecondary leading-relaxed mb-6 flex-grow">
      {review.text}
    </p>

    <div className="flex justify-between items-center pt-4 border-t border-grey">
      <Rating rating={review.rating} />
      <p className="text-sm text-textMuted">
        {review.relative_time_description}
      </p>
    </div>
  </div>
)

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    map = new google.maps.Map(document.createElement('div'))
    getPlaceDetail(data => data && setReviews(data.reviews))
  }, [])

  return reviews.length ? (
    <section className="py-24 px-6 bg-offWhite">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div
            className="inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
            style={{
              background:
                'linear-gradient(135deg, rgba(99, 91, 255, 0.1) 0%, rgba(17, 239, 227, 0.1) 100%)',
              color: '#635bff'
            }}
          >
            Patient Reviews
          </div>
          <h2 className="text-4xl font-bold text-navy mb-4">
            What Our Patients Say
          </h2>
          <p className="text-lg text-textSecondary max-w-2xl mx-auto">
            We're proud to have earned the trust of families throughout Oregon
            City. Here's what they have to say.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {reviews.slice(0, 4).map((review, idx) => (
            <ReviewCard key={idx} review={review} />
          ))}
        </div>

        {/* Powered by Google */}
        <div className="flex justify-center mt-8">
          <img
            style={{ height: 18, opacity: 0.6 }}
            src={poweredByGoog}
            alt="Powered By Google"
          />
        </div>
      </div>
    </section>
  ) : null
}

export default GoogleReviews
